import { Tag, TagProps } from "antd"

type BetaTagProps = Omit<TagProps, "children" | "color"> & {
  className?: string
}

export function BetaTag({ className, ...props }: BetaTagProps) {
  return (
    <Tag {...props} className={className} color="orange">
      BETA
    </Tag>
  )
}
